export default Object.freeze({
    EMAIL_CONFIRMED: "Your email has been confirmed ! Thank you.",
    CHECK_CONFIRMATION_EMAIL: "Please check your emails and follow the instructions. Check your spam emails if you can't find it. ",
    LOGGED_IN: "You are logged in. ",
    LOGGED_OUT: "You are logged out. ",
    ERROR: "Something went wrong. ",
    SAVED: "Saved successfully. ",
    CONFIRMED: "Booking confirmed. ",
    CANCELLED: "Booking cancelled. ",
    PAYMENT: "The payment has been approved ",
    PAYMENT_FAILED: "The payment failed ",
    SENT: "The message has been sent successfully. We sent you a copy, so please check it didn't end up in junk mail, if so mark it as NOT junk so you don't miss our reply. ",
    DELETED: "Deleted successfully. ",
    LET_ME_KNOW: "We received your request successfully. We sent you a copy, so please check it didn't end up in junk mail, if so mark it as NOT junk so you don't miss our reply. ",
    RESET_PASSWORD_ERROR: "Please, try to request a new reset password. The current link might be expired. ",
})

